<template>
  <div class="info-box static">
    <div class="flex-1 overflow-hidden gap-x-3 flex">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="overflow-y-auto px-2.5 flex-1"
      >
        <ul class="grid gap-x-5" style="grid-template-columns: 1fr auto">
          <el-form-item
            label="酒店名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入酒店名称', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-switch
              v-model="state.model.status"
              active-text="启用"
              inactive-text="禁用"
              inline-prompt
              :active-value="1"
              :inactive-value="0"
            />
          </el-form-item>
        </ul>
        <ul class="grid gap-x-5" style="grid-template-columns: 3.13fr auto 5fr">
          <el-form-item
            label="联系人"
            prop="contact_name"
            :rules="[
              { required: true, message: '请输入联系人', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.contact_name"></el-input>
          </el-form-item>
          <el-form-item
            label="称谓"
            prop="contact_title"
            :rules="[
              { required: true, message: '请选择称谓', trigger: 'blur' },
            ]"
          >
            <div
              class="rounded px-3 cursor-pointer"
              :class="
                state.model.contact_title == '先生'
                  ? ' bg-green-800 text-white'
                  : ' text-gray-400 border'
              "
              @click="state.model.contact_title = '先生'"
            >
              先生
            </div>
            <div
              class="rounded px-3 ml-2 cursor-pointer"
              :class="
                state.model.contact_title == '女士'
                  ? ' bg-red-600 text-white'
                  : ' text-gray-400 border'
              "
              @click="state.model.contact_title = '女士'"
            >
              女士
            </div>
          </el-form-item>
          <el-form-item
            label="联系人电话"
            prop="contact_phone"
            :rules="[
              { required: true, message: '请输入联系人电话', trigger: 'blur' },
              { validator: $phone_rules, trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.contact_phone"></el-input>
          </el-form-item>
        </ul>
        <ul class="gap-x-5 grid grid-cols-2">
          <el-form-item
            label="负责人"
            prop="belonger_id"
            :rules="[
              { required: true, message: '请选择负责人', trigger: 'blur' },
            ]"
          >
            <c_userselect
              v-model="state.model.belonger_id"
              @change:item="
                (item) => {
                  state.model.belonger_department_id = item.department_id;
                }
              "
            />
          </el-form-item>
          <el-form-item label="星级">
            <el-select v-model="state.model.d_hotel_rating_id">
              <el-option
                v-for="item in state.xj_data"
                :key="item"
                :label="item.name"
                :value="item.id"
              ></el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadXj"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
        </ul>
        <el-form-item
          label="详细地址"
          prop="address"
          :rules="[
            { required: true, message: '请输入详细地址', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                if (!state.model.longitude)
                  return callback(
                    new Error('请在地图上通过鼠标左键点击标注地理位置'),
                  );
                else callback();
              },
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.address"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="state.model.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div class="flex-1 relative">
        <c_map
          :point="[state.model?.longitude, state.model?.latitude]"
          @setAddress="
            (item) => {
              if (!state.model.province) {
                state.model.province = item.province;
                state.model.city = item.city;
                state.model.district = item.district;
              }
              state.model.longitude = item.longitude;
              state.model.latitude = item.latitude;

              state.model.address = item.address;
              state.model.area = [item.province, item.city, item.district];
            }
          "
        />
      </div>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { hotel_detail, hotel_add, hotel_edit } from "@/http/hotel";
import { dic_getHotelRating } from "@/http/data";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
      },
    });
    onMounted(() => {
      onLoadXj();
      if (props.id) {
        hotel_detail(props.id).then((res) => {
          if (res.status == 200) {
            const data = res.data?.data;
            state.model = data;
          }
        });
      }
    });

    //获取酒店星级字典数据
    const onLoadXj = () => {
      dic_getHotelRating().then((res) => {
        if (res.status == 200) state.xj_data = res.data.data;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            hotel_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            hotel_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", res.data?.data?.id);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadXj,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
